export class TransactionManager {
  constructor() {
    this.operations = [];
    this.completedOperations = [];
  }

  addOperation(operation) {
    this.operations.push(operation);
  }

  async execute() {
    const results = [];
    
    try {
      for (let i = 0; i < this.operations.length; i++) {
        const operation = this.operations[i];
        const result = await operation.execute();
        results.push(result);
        this.completedOperations.push(operation);
        
        // Update progress if needed
        if (operation.progressUpdate) {
          operation.progressUpdate();
        }
      }
      return results;
    } catch (error) {
      // Rollback completed operations in reverse order
      await this.rollback();
      throw error;
    }
  }

  async rollback() {
    // Rollback in reverse order of completion
    for (let i = this.completedOperations.length - 1; i >= 0; i--) {
      const operation = this.completedOperations[i];
      try {
        if (operation.rollback) {
          await operation.rollback();
        }
      } catch (rollbackError) {
        console.error('Rollback failed for operation:', operation, rollbackError);
        // Continue with other rollbacks even if one fails
      }
    }
    
    // Clear the operations arrays
    this.operations = [];
    this.completedOperations = [];
  }
}

export class DatabaseOperation {
  constructor(executeFn, rollbackFn = null, progressUpdate = null) {
    this.execute = executeFn;
    this.rollback = rollbackFn;
    this.progressUpdate = progressUpdate;
  }
}

// Retry utility for network resilience
export const withRetry = async (operation, maxRetries = 3, delay = 1000) => {
  let lastError;
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;
      console.warn(`Attempt ${attempt} failed:`, error);
      
      if (attempt < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, delay * attempt));
      }
    }
  }
  
  throw lastError;
};